class StaffStrip {
	constructor( block ) {
		this.staffStrip = block;

		function moveElement(el, before, after) {
			if (window.innerWidth < 768) {
				after.appendChild(el);
			} else {
				// before.parentNode.insertBefore(el, before.nextSibling);
				before.appendChild(el);
			}
		}

		var staffQuote = this.staffStrip.querySelector(".block-staff-strip__quote");
		var imageColumn = this.staffStrip.querySelector(".block-staff-strip__image-column");
		var quoteWrap = this.staffStrip.querySelector(".block-staff-strip__quote-wrap");

		if (staffQuote !== null) {
			moveElement(staffQuote, quoteWrap, imageColumn);

			window.addEventListener('resize', function(event){
				moveElement(staffQuote, quoteWrap, imageColumn);
			});
		}

	}
}

export default StaffStrip;
